import type { PortfolioItem }  from "../types/portfolio";

export const PORTFOLIO_LINKS = {
  colichainL2: "https://coliseum-marketplace-live.vercel.app/",
  fractionnaire: "https://desert-tech-rwa-marketplace.vercel.app/",
  trustify: "https://trustify-app.vercel.app/dashboard/overview/transactions",
  unicover: "https://www.unicover.it/",
  spyral: "https://spyral.studio/",
  morningside: "https://morning-side-ai.vercel.app/",
  coliseumDex: "https://coliseum-cross-chain-dex.vercel.app/",
  nexlabs: "https://www.nexlabs.io/",
  napuleth: "https://www.napuleth.org/",
  modus: "https://modusdapp.org/",
  ctrlshift: "https://www.ctrlshift.events/",
  siliconplan: "https://www.silicon-plan.live/",
  urano: "https://www.uranoecosystem.com/",
  colichainMarketplace: "https://coliseum-marketplace-live.vercel.app/",
  giordanoRispo: "https://www.giordanorispo.com/",
  quantumCustody: "https://quantum-custody.vercel.app/",
  ukGovernment: "https://quantumdash-ekgqukfo.manus.space/",
  quantumCompliance: "https://postquantumcompliance.com/",
  sitelab: "https://sitelab.build/",
  nmkCreativeHub: "https://www.nmkcreativehub.it/",
  artstake: "",
  wishinwell: "",
  rumoo: "",
  drugrepAi: "https://www.drugrepai.com/",
  connectionsAi: "",
} as const;

export const portfolioItems: PortfolioItem[] = [
  {
    id: "1",
    title: "Nexlabs",
    description:
      "Decentralized investment platform that allows users to create, manage, and invest in customizable on-chain indices combining crypto assets, tokenized real-world assets (RWAs), and commodities.",
    type: ["DeFi", "AI", "Social"],
    tools: ["UI/UX", "Frontend", "Backend", "Blockchain"],
    carouselProjectId: "nex",
    link: PORTFOLIO_LINKS.nexlabs,
  },
  {
    id: "2",
    title: "Sitelab",
    description:
      "Platform for building fast, custom websites using templates to streamline development and reduce complexity. It combines development, hosting, and support into a single solution.",
    type: ["AI"],
    tools: ["UI/UX", "Frontend", "Backend"],
    carouselProjectId: "sitelab",
    link: PORTFOLIO_LINKS.sitelab,
  },
  {
    id: "3",
    title: "Colichain",
    description:
      "Layer 2 blockchain designed for tokenized real-world assets, frictionless DeFi, and developer-first scalability.",
    type: ["DeFi", "RWA", "L1/L2"],
    tools: ["UI/UX", "Frontend", "Backend", "DB / Storage", "Blockchain"],
    carouselProjectId: "colichain-marketplace",
    link: PORTFOLIO_LINKS.colichainMarketplace,
  },
  {
    id: "4",
    title: "Quantum Compliance",
    description:
      "Digital platform designed to help organizations evaluate and prepare their cybersecurity infrastructure for the emerging risks posed by quantum computing.",
    type: ["Quantum"],
    tools: ["UI/UX", "Frontend"],
    carouselProjectId: "quantum-compliance",
    link: PORTFOLIO_LINKS.quantumCompliance,
  },
  {
    id: "5",
    title: "Spyral - Blockchain platform for music rights & royalties",
    description:
      "Spyral revolutionizes music rights and royalty management using blockchain and AI-powered metadata. Integrated with top DAWs (Logic Pro, Pro Tools, Ableton Live, FL Studio), it enables artists to tokenize tracks at creation and ensures transparent, accurate royalty tracking.",
    type: ["AI", "Social"],
    tools: ["UI/UX", "Frontend", "Backend", "DB/Storage", "Blockchain"],
    carouselProjectId: "spyral",
    link: PORTFOLIO_LINKS.spyral,
  },
  {
    id: "6",
    title: "MorningsideAI – AI consulting & development for enterprises",
    description:
      "MorningsideAI is a cutting-edge AI consulting and development company based in New Zealand, specializing in delivering innovative artificial intelligence solutions to businesses across sectors. With a focus on agility, precision, and forward-thinking strategy, MorningsideAI helps organizations harness the power of AI to drive real-world impact.",
    type: ["Social"],
    tools: ["UI/UX", "Frontend"],
    carouselProjectId: "morningside",
    link: PORTFOLIO_LINKS.morningside,
  },
  {
    id: "7",
    title: "Coliseum - NFT Marketplace for Sports Memorabilia",
    description:
      "Coliseum is a cross-chain decentralized exchange (DEX) designed to enable seamless, secure trading between Bitcoin, Solana, and Ethereum-based tokens. By eliminating the need for centralized intermediaries, Coliseum addresses blockchain fragmentation, offering a unified platform for efficient cross-chain swaps.",
    type: ["NFT", "Social"],
    tools: ["UI/UX", "Frontend", "Backend", "Blockchain"],
    carouselProjectId: "coliseum-dex",
    link: PORTFOLIO_LINKS.coliseumDex,
  },
  {
    id: "8",
    title: "Colichain — L2 Infrastructure for the RWA",
    description:
      "Colichain is a next-generation Layer 2 blockchain designed to bridge the gap between digital assets and real-world value. Built for scalability, transparency, and real-world adoption, Colichain enables tokenization of physical and digital assets",
    type: ["DeFi", "RWA", "NFT"],
    tools: ["UI/UX", "Frontend", "Backend", "Blockchain"],
    carouselProjectId: "colichain-l2",
    link: PORTFOLIO_LINKS.colichainL2,
  },
  {
    id: "9",
    title: "UK Government",
    description:
      "Web platform designed to provide a centralized dashboard for monitoring and managing digital assets within a modern fintech or blockchain infrastructure.",
    type: ["Quantum"],
    tools: ["UI/UX", "Frontend"],
    carouselProjectId: "uk-government",
    link: PORTFOLIO_LINKS.ukGovernment,
  },
  {
    id: "10",
    title: "Artstake",
    description:
      "Web3-powered platform for discovering, tracking, and trading digital art assets. It combines portfolio management, real-time market interaction, and seamless onboarding to create a mobile-first experience for NFT collectors and artists.",
    type: ["NFT"],
    tools: ["Blockchain", "UI/UX", "Frontend", "Backend"],
    carouselProjectId: "artstake",
    link: PORTFOLIO_LINKS.artstake,
  },
  {
    id: "11",
    title: "Ctrlshift:",
    description:
      "A world-class summit uniting the pioneers of AI, Quantum Computing, and Web3.",
    type: ["Social", "DeFi", "RWA", "NFT"],
    tools: ["Blockchain"],
    carouselProjectId: "ctrlshift",
    link: PORTFOLIO_LINKS.ctrlshift,
  },
  {
    id: "12",
    title: "Silicon Plan:",
    description:
      "Your AI-Powered Platform for Business Plans, Pitches & Financial Forecasts.",
    type: ["Social", "AI"],
    tools: ["UI/UX", "Frontend", "Backend", "DB / Storage"],
    carouselProjectId: "siliconplan",
    link: PORTFOLIO_LINKS.siliconplan,
  },
  {
    id: "13",
    title: "URANO",
    description:
      "Ecosystem is a full-stack platform powering secure and scalable tokenization of Real-World Assets",
    type: ["Social", "AI", "DeFi", "RWA"],
    tools: ["UI/UX", "Frontend", "Backend", "DB / Storage"],
    carouselProjectId: "urano",
    link: PORTFOLIO_LINKS.urano,
  },
  {
    id: "14",
    title: "Trustify — Blockchain Platform for Food Quality and Safety",
    description:
      "Trustify restores trust in high-quality food products through a blockchain-based track-and-trace system that ensures full transparency from farm to table. Every stage—harvesting, quality checks, inspections, distribution, and retail—is recorded on-chain. Using dynamic NFTs and smart contracts, each product batch receives a unique, verifiable ID, enabling end-to-end traceability and verification of authenticity, origin, and quality compliance.",
    type: ["DeFi", "NFT", "AI", "Social"],
    tools: ["UI/UX", "Frontend", "Backend", "Blockchain"],
    carouselProjectId: "trustify",
    link: PORTFOLIO_LINKS.trustify,
  },
  {
    id: "15",
    title: "Rumoo",
    description:
      "Application designed to connect small-to-medium Food & Hospitality brands with micro-influencers for authentic, low-budget collaborations.",
    type: ["Social"],
    tools: ["UI/UX", "Frontend", "Backend"],
    carouselProjectId: "rumoo",
    link: PORTFOLIO_LINKS.rumoo,
  },
  {
    id: "16",
    title: "Quantum Custody",
    description:
      "Conceptual platform focused on the secure storage and management of digital assets in a future shaped by advanced cryptography and emerging quantum technologies.",
    type: ["Quantum"],
    tools: ["UI/UX", "Frontend", "DB / Storage"],
    carouselProjectId: "quantum-custody",
    link: PORTFOLIO_LINKS.quantumCustody,
  },
  {
    id: "17",
    title: "Web3 community event celebrating innovation in Naples",
    description:
      "NapulETH is a Web3 event bringing builders, creators, and innovators together in Naples to explore blockchain, DeFi, and decentralized culture. With talks, workshops, and networking, it fosters collaboration and showcases the future of decentralized tech.",
    type: ["Social"],
    tools: ["UI/UX", "Frontend"],
    carouselProjectId: "napuleth",
    link: PORTFOLIO_LINKS.napuleth,
  },
  {
    id: "18",
    title: "UNICOVER - Insurance Brokerage and Risk Management Solutions",
    description:
      "Unicover provides advanced insurance brokerage and risk management services tailored for businesses and individuals. With decades of expertise, it delivers customized coverage, asset protection, and compliance solutions, helping clients minimize risks globally.",
    type: ["DeFi", "Social"],
    tools: ["Frontend", "DevOps", "Blockchain"],
    carouselProjectId: "unicover",
    link: PORTFOLIO_LINKS.unicover,
  },
  {
    id: "19",
    title: "FRACTIONNAIRE - Real Estate RWA Platform for Digital Ownership",
    description:
      "Fractionnaire bridges real estate and DeFi through blockchain tokenization and smart contract automation, enabling fractional ownership, seamless secondary trading, and compliant investment workflows.",
    type: ["RWA", "DeFi"],
    tools: ["UI/UX", "Frontend", "DevOps", "Blockchain"],
    carouselProjectId: "fractionnaire",
    link: PORTFOLIO_LINKS.fractionnaire,
  },
  {
    id: "20",
    title: "NMK Creative Hub",
    description:
      "Integrated creative agency that delivers end-to-end communication solutions—from branding and digital strategy to content production and experiential marketing.",
    type: ["Agency"],
    tools: ["UI/UX", "Frontend", "Backend"],
    carouselProjectId: "nmk-creative-hub",
    link: PORTFOLIO_LINKS.nmkCreativeHub,
  },
  {
    id: "21",
    title: "Modus - Fractionalized Real Estate",
    description:
      "Modus is a real estate investment platform that allows community members to invest early in development projects, maximizing returns. By partnering with land developers and integrating blockchain technology, Modus establishes a decentralized, self-governing system that prioritizes community interests.",
    type: ["Social"],
    tools: ["UI/UX", "Frontend"],
    carouselProjectId: "modus",
    link: PORTFOLIO_LINKS.modus,
  },
  {
    id: "22",
    title: "Wishinwell",
    description:
      "Blockchain-powered charity platform that ensures transparent, traceable, and verifiable donations. It connects donors and nonprofits in a single ecosystem, using technology to build trust and eliminate opacity in the giving process.",
    type: ["Social"],
    tools: ["Blockchain", "UI/UX", "Frontend", "Backend"],
    carouselProjectId: "wishinwell",
    link: PORTFOLIO_LINKS.wishinwell,
  },
  {
    id: "23",
    title: "Giordano Rispo",
    description:
      "The website of Giordano Rispo is a minimalist photography portfolio designed to showcase the artist’s visual work through a clean, distraction-free interface.",
    type: ["Social"],
    tools: ["UI/UX", "Frontend"],
    carouselProjectId: "giordano-rispo",
    link: PORTFOLIO_LINKS.giordanoRispo,
  },
  {
    id: "24",
    title: "DrugRepAI",
    description:
      "AI-driven project that explores how different substances can influence human emotions and mental states.",
    type: ["AI"],
    tools: ["UI/UX", "Frontend", "Backend"],
    carouselProjectId: "drugrep-ai",
    link: PORTFOLIO_LINKS.drugrepAi,
  },
  {
    id: "25",
    title: "Connections AI",
    description:
      "Geo-localized mobile platform designed to connect people and professionals in real time, enabling them to offer or request local services with trust, immediacy, and transparency.",
    type: ["Social"],
    tools: ["UI/UX", "Frontend", "Backend"],
    carouselProjectId: "connections-ai",
    link: PORTFOLIO_LINKS.connectionsAi,
  },
];

